/**
 * 存储localStorage
 */
export const setLocalStorage = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getLocalStorage = name => {
  if (!name) return;
  let data = window.localStorage.getItem(name);

  return data ? JSON.parse(data) : undefined;
};

/**
 * 删除localStorage
 */
export const removeLocalStorage = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * Cookie操作
 * @type {{get(*): *, set(*, *, *=, *=, *=): void, remove(*=): void}}
 */
export const Cookie = {
  /**
   * getCookie
   * @param name
   * @returns {*}
   */
  get(name) {
    var strCookie = document.cookie;
    var arrCookie = strCookie.split('; ');
    for (var i = 0; i < arrCookie.length; i++) {
      var arr = arrCookie[i].split('=');
      if (arr[0] == name) return arr[1];
    }
    return '';
  },

  /**
   * 添加cookie
   * @param name
   * @param value
   * @param expiresHours
   * @param domain
   */
  set(name, value, expiresDays, domain, path) {
    var cookieString = name + '=' + (value ? value : '');
    var date = new Date();

    if (domain != undefined) domain = ';domain=' + domain;
    else domain = '';

    date.setTime(date.getTime() + (expiresDays || 1) * 24 * 3600 * 1000);
    cookieString =
      cookieString +
      domain +
      '; path=' +
      (path || '/') +
      '; expires=' +
      date.toGMTString();
    document.cookie = cookieString;
  },

  /**
   * 删除cookie
   * @param name
   */
  remove(name) {
    this.set(name, '', -1);
  }
};

/**
 * 权限对比
 * @param matchArr
 * @param userArr
 * @returns {boolean}
 */
export function authorityComparison(matchArr, userArr) {
  if (!userArr) {
    // 如果没有设置权限码，默认不需要
    return true;
  }
  let temp = false;
  matchArr = matchArr || [];
  // console.log('当前权限码matchArr',matchArr)
  // console.log('当前权限码userArr',userArr)
  if (typeof userArr === 'string' || typeof userArr === 'number') {
    return matchArr.includes(userArr);
  } else {
    userArr.forEach(item => {
      temp = temp || matchArr.includes(item);
    });
  }
  return temp;
}

export function throttle(fn, wait) {
  var timer = null;
  return function() {
    var context = this;
    var args = arguments;
    if (!timer) {
      timer = setTimeout(function() {
        fn.apply(context, args);
        timer = null;
      }, wait);
    }
  };
}
/**
 * 防抖函数
 * @param {*} func 传入方法
 * @param {*} delay 延迟时间
 */
export function debounce(func, delay) {
  let timer;
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

/**
 * 拼接url
 * @param url
 * @param param
 * @returns {string|string}
 */
export function createURL(url, param) {
  var urlLink = '';
  for (let key in param) {
    let link = '&' + key + '=' + param[key];
    urlLink += link;
  }
  urlLink = url + '?' + urlLink.substr(1);
  return urlLink;
}

/**
 * 获取当前的日期 格式“yyyy-MM-dd”
 * @returns {string}
 */
export function getcurrentDate(nS) {
  var date = nS ? new Date(nS) : new Date();
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  mon = mon > 9 ? mon : '0' + mon;
  var day = date.getDate();
  day = day > 9 ? day : '0' + day;
  return '' + year + '-' + mon + '-' + day;
}

/**
 * 获取当前的日期 格式“yyyy-MM-dd” hh:mm:ss
 * @returns {string}
 */
export function getcurrentDateAll(nS) {
  var date = nS ? new Date(nS) : new Date();
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  mon = mon > 9 ? mon : '0' + mon;
  day = day > 9 ? day : '0' + day;
  hours = hours > 9 ? hours : '0' + hours;
  minutes = minutes > 9 ? minutes : '0' + minutes;
  seconds = seconds > 9 ? seconds : '0' + seconds;
  return (
    '' +
    year +
    '-' +
    mon +
    '-' +
    day +
    ' ' +
    hours +
    ':' +
    minutes +
    ':' +
    seconds
  );
}

/**
 * 添加iframe到文档中
 * @param url
 */
export function addIframeDom(url) {
  let iframe;
  try {
    // IE6, IE7
    iframe = document.createElement('<iframe name="check_oa_login">');
  } catch (e) {
    iframe = document.createElement('iframe');
    iframe.name = 'oa_login';
  }
  iframe.src = url;
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.position = 'absolute';
  iframe.style.top = '-9999px';
  iframe.style.left = '-9999px';
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);
}
